define('sdb_plpmodifications_template.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('sdb_plpmodifications_template', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/SuiteDB/SDBProductModifications/1.5.9/', 'extensions/SuiteDB/SDBProductModifications/1.5.9/', Handlebars);
});